@if ({
  openRightPanel: true,
  openViewsPanel: false,
  openExportPanel: false
  }; as variables) {
  <div
    class="d-flex align-items-center justify-content-between w-100"
    >
    @if (!authService.readOnlyMode()) {
      <app-dispatch-recall
        [active]="active()"
        [selectedWOstatus]="selectedWOstatus()"
        (onRecallOrDispatchDone)="onCloseReloadGrid($event)"
        >
      </app-dispatch-recall>
    }
    @if (!authService.readOnlyMode()) {
      <app-hold-popup
        [selectedWorkOrders]="selectedWorkOrders()"
        (onCloseHoldPopup)="onCloseReloadGrid($event)"
        >
      </app-hold-popup>
    }
    <app-blackout
      [active]="active()"
      [readOnlyMode]="authService.readOnlyMode()"
      [selectedWOstatus]="selectedWOstatus()"
      (completedEvent)="onCloseReloadGrid($event)"
    ></app-blackout>
    @if (!authService.readOnlyMode()) {
      <app-mass-status-update
        [active]="active()"
        [selectedWorkOrders]="selectedWorkOrders()"
        (completedEvent)="onCloseReloadGrid($event)"
      ></app-mass-status-update>
    }
    <div class="me-2 ms-auto d-flex">
      <div class="">
        <button
          class="px-2 me-2"
          kendoButton
          fillMode="outline"
          rounded="large"
          [themeColor]="'secondary'"
        [title]="
          _clientWO.bulkActionsDisabled()
            ? ('HOME.STREAM.DISABLED_TOOLTIP'
              | translate: { count: (_clientWO.loadedRowCount() | number) })
            : ('HOME_COMPONENTS.ACTIONS_RIBBON.EXPORT' | translate)
        "
          [disabled]="workOrders().length === 0 || _clientWO.bulkActionsDisabled()"
          #exportAnchor
          (click)="variables.openExportPanel = true"
          >
          <fa-icon [icon]="faDownload" class="pe-1"></fa-icon>
          {{ 'HOME_COMPONENTS.ACTIONS_RIBBON.EXPORT' | translate }}
        </button>
        @if (variables.openExportPanel) {
          <kendo-popup
            class="popup"
            [anchor]="exportAnchor"
            [anchorAlign]="{ horizontal: 'right', vertical: 'bottom' }"
            [popupAlign]="{ horizontal: 'right', vertical: 'top' }"
            style="margin-top: 8px"
            >
            <div class="d-flex justify-content-between align-items-center">
              <div class="font-weight-bold small-text py-2 px-3">
                {{ 'HOME_COMPONENTS.ACTIONS_RIBBON.EXPORT_WORK_ORDERS' | translate }}
              </div>
              <fa-icon
                role="button"
                class="py-2 px-3 cursor-pointer"
                tabindex="0"
                (click)="variables.openExportPanel = false"
                [icon]="faTimes"
              ></fa-icon>
            </div>
            <div class="bg-white d-grid">
              <div
                class="d-flex align-items-center cursor-pointer menu-item px-2 py-1"
                (click)="export('xlsx')"
                >
                <fa-icon
                  role="button"
                  class="px-2"
                  tabindex="0"
                  [icon]="faFileXls"
                ></fa-icon>
                <div class="small-text">{{ 'HOME_COMPONENTS.ACTIONS_RIBBON.XLS' | translate }}</div>
              </div>
              <div
                class="mt-2 d-flex align-items-center cursor-pointer menu-item px-2 py-1"
                (click)="export('csv')"
                >
                <fa-icon
                  role="button"
                  class="px-2"
                  tabindex="0"
                  [icon]="faFileCsv"
                ></fa-icon>
                <div class="small-text">{{ 'HOME_COMPONENTS.ACTIONS_RIBBON.CSV' | translate }}</div>
              </div>
              <div
                class="mt-2 d-flex align-items-center cursor-pointer menu-item px-2 py-1"
                (click)="exportIFSFile()"
                >
                <fa-icon
                  role="button"
                  class="px-2"
                  tabindex="0"
                  [icon]="faFile"
                ></fa-icon>
                <div class="small-text">{{ 'HOME_COMPONENTS.ACTIONS_RIBBON.IFS' | translate }}</div>
              </div>
              <div
                class="mt-2 d-flex align-items-center cursor-not-allowed px-2 py-1"
                >
                <fa-icon class="px-2" [icon]="faFilePdf"></fa-icon>
                <div class="small-text">{{ 'HOME_COMPONENTS.ACTIONS_RIBBON.PDF' | translate }}</div>
              </div>
            </div>
          </kendo-popup>
        }
      </div>
      <button
        class="px-2 me-2"
        kendoButton
        [fillMode]="variables.openViewsPanel ? 'solid' : 'outline'"
        rounded="large"
        themeColor="primary"
      [title]="
        _clientWO.bulkActionsDisabled()
          ? ('HOME.STREAM.DISABLED_TOOLTIP'
            | translate: { count: (_clientWO.loadedRowCount() | number) })
          : ('HOME_COMPONENTS.ACTIONS_RIBBON.VIEW' | translate)
      "
      (click)="
        variables.openViewsPanel = true; variables.openRightPanel = false
      "
        >
        <div class="d-flex">
          <fa-icon [icon]="faBookmark" class="pe-2"></fa-icon>
          {{ 'HOME_COMPONENTS.ACTIONS_RIBBON.VIEW' | translate }} -
          @if (active()) {
            {{ active()?.title }}
          } @else {
            <kendo-skeleton
              animation="pulse"
              [width]="60"
              [height]="20"
              class="ms-1"
            ></kendo-skeleton>
          }
          <fa-icon [icon]="faAngleDown" class="ps-3"></fa-icon>
        </div>
      </button>
      <div class="d-block border-x me-2"></div>
      <button
        class="px-2 me-2"
        kendoButton
        [fillMode]="variables.openRightPanel ? 'solid' : 'outline'"
        rounded="large"
        themeColor="primary"
        [title]="'HOME_COMPONENTS.ACTIONS_RIBBON.FILTERS' | translate"
      (click)="
        variables.openRightPanel = true; variables.openViewsPanel = false
      "
        >
        <fa-icon [icon]="faFilter" class="pe-1"></fa-icon>
        {{ 'HOME_COMPONENTS.ACTIONS_RIBBON.FILTERS' | translate }}
      </button>
    </div>
    <!--to hide is important to avoid the component reloading the data. if we use *ngIf it recreates the component and call again the server -->
    <div class="sidebar-filter" [class.show]="variables.openRightPanel">
      <div
        class="px-4 py-3 position-absolute end-100 d-flex align-items-center btn btn-secondary rounded-0 border"
        (click)="variables.openRightPanel = false"
        #hideAnchor
        >
        <fa-icon [icon]="faChevronsRight" class="pe-1"></fa-icon>
        {{ 'HOME_COMPONENTS.ACTIONS_RIBBON.HIDE' | translate }}
      </div>
      <div class="sidebar-filter--container h-100">
        @if (variables.openRightPanel) {
          <app-master-filter
            [hideAnchor]="hideAnchor"
            (filterEvent)="variables.openRightPanel = false"
            (save)="toggleAddViewDialog($event)"
            [active]="active()"
          ></app-master-filter>
        }
      </div>
    </div>
    <div class="sidebar-filter" [class.show]="variables.openViewsPanel">
      <div
        class="px-4 py-3 position-absolute end-100 d-flex align-items-center btn btn-secondary rounded-0 border"
        (click)="variables.openViewsPanel = false"
        #hideAnchor
        >
        <fa-icon [icon]="faChevronsRight" class="pe-1"></fa-icon>
        {{ 'HOME_COMPONENTS.ACTIONS_RIBBON.HIDE' | translate }}
      </div>
      <div class="sidebar-filter--container h-100 bg-white">
        <div
          class="filter-header d-flex p-3 align-items-center justify-content-between"
          >
          <div class="d-flex align-items-center">{{ 'HOME_COMPONENTS.ACTIONS_RIBBON.VIEWS' | translate }}</div>
          <button
            kendoButton
            fillMode="clear"
            rounded="small"
            themeColor="primary"
            [size]="'small'"
            (click)="toggleAddViewDialog(true)"
            >
            <i class="fa-regular fa-plus"></i>
            {{ 'HOME_COMPONENTS.ACTIONS_RIBBON.CREATE' | translate }}
          </button>
        </div>
        <app-views
          class="d-block pb-2"
          (save)="toggleAddViewDialog($event)"
        (onSelect)="
          variables.openRightPanel = true; variables.openViewsPanel = false
        "
        ></app-views>
      </div>
    </div>
  </div>
}

<!-- Add view dialog -->
@if (showAddViewDialog) {
  <app-view-save
    [model]="createViewModel()"
    [isNew]="isNew"
    (save)="save($event)"
    (cancel)="toggleAddViewDialog()"
  ></app-view-save>
}
